export const LOAD_CLIENT_OFFER_CHART_DATA_SUCCESS = "LOAD_CLIENT_OFFER_CHART_DATA_SUCCESS";
export const LOAD_CLIENT_OFFER_STATUS_CHART_DATA_SUCCESS = "LOAD_CLIENT_OFFER_STATUS_CHART_DATA_SUCCESS";
export const LOAD_TOP_CLIENTS_CHART_DATA_SUCCESS = "LOAD_TOP_CLIENTS_CHART_DATA_SUCCESS";
export const LOAD_LATEST_CLIENTS_CHART_DATA_SUCCESS = "LOAD_LATEST_CLIENTS_CHART_DATA_SUCCESS";
